import translationDEV from '../utils/i18n/locales/dev.json';
import translationNLnl from '../utils/i18n/locales/nl.json';
import translationEN from '../utils/i18n/locales/en.json';
import translationSV from '../utils/i18n/locales/sv.json';
import i18next, { Callback } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import { initReactI18next } from 'react-i18next';

import { I18Language } from './i18n.types';
import BusinessUnitLanguageDetector from './i18nBussinessUnitLanguageDetector';
import SavedLanguageDetector from './i18nSavedLanguageDetector';

export const i18nLanguageStorageKey = 'i18nextLng';

const languageDetector = new LanguageDetector();
languageDetector.addDetector(BusinessUnitLanguageDetector);
languageDetector.addDetector(SavedLanguageDetector);

const supportedLngs: I18Language[] = [
	'nl',
	'nl-NL',
	'nl-BE',
	'en',
	'fr',
	'fr-BE',
	'sv',
	'sv-SE',
	'dev'
];
const fallbackLng: Record<string, I18Language[]> = {
	'nl-NL': ['nl-BE', 'en', 'dev'],
	'nl-BE': ['nl-NL', 'en', 'dev'],
	nl: ['nl-NL', 'nl-BE', 'en', 'dev'],
	'sv-SE': ['sv', 'en', 'dev'],
	'fr-BE': ['fr', 'en', 'dev'],
	default: ['en', 'dev']
};

export const i18nInit = async (initCallback: () => Callback | undefined) => i18next
	.use(initReactI18next)
	.use(languageDetector)
	.init({
		compatibilityJSON: 'v3', //https://www.i18next.com/misc/migration-guide#v-20-x-x-to-v-21-0-0
		fallbackLng,
		debug: true,
		keySeparator: '.',
		detection: {
			order: [
				'querystring',
				'localStorage',
				'businessUnitLanguageDetector',
				'navigator'
			],
			lookupQuerystring: 'lng',
			lookupSessionStorage: i18nLanguageStorageKey,
			caches: ['localStorage']
		},
		initImmediate: false,
		supportedLngs,
		resources: {
			dev: translationDEV,
			nl: translationNLnl,
			en: translationEN,
			sv: translationSV,
		},
		interpolation: {
			escapeValue: false
		},
		react: {
			useSuspense: false
		}
	},
	initCallback()
	);

i18next.services.formatter?.add('dateFormatter', (val) => {
	return moment(val).local().format('DD/MM/yyyy');
});

i18next.services.formatter?.add('lower', (val: string) => {
	return val.toLowerCase();
});

i18next.services.formatter?.add('sentence', (val: string) => {
	return val.charAt(0).toUpperCase() + val.substring(1).toLowerCase();
});

export default i18next;
